import { cn } from "@/utils/cn";
import { formatMoney } from "@/utils/currency";

interface MoneyTextProps {
  amountMinor: number | null;
  currency?: string;
  strong?: boolean;
  /** Gray for a forecast or quoted figure. Zero is gray without it. */
  muted?: boolean;
  /** A running or net figure, such as cash or what is left: red below zero. A flow is never red (DD-054). */
  balance?: boolean;
  className?: string;
}

/** One money cell style (DD-054): tabular figures, zero gray, red only for a balance below zero, "—" when unknown. */
export function MoneyText({ amountMinor, currency = "EUR", strong = false, muted = false, balance = false, className }: MoneyTextProps) {
  if (amountMinor === null) return <span className={cn("text-gray-400", className)}>—</span>;
  return (
    <span
      className={cn(
        "tabular-nums whitespace-nowrap",
        balance && amountMinor < 0 ? "text-red-600" : muted || amountMinor === 0 ? "text-gray-400" : "text-gray-900",
        strong && "font-semibold",
        className
      )}
    >
      {formatMoney(amountMinor, currency)}
    </span>
  );
}
